import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 3H8V15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M20 21V3H16V21H20Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4 21V3H8V21H4Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 3V21M4 3H8M4 3H3M20 3V21M20 3H16M20 3H21M4 21H3M4 21C9 21 3 21 8 21M20 21H21M20 21H16M8 3H16M8 3C8 8.9797 8 9.84222 8 15M8 21H16M8 21C8 19.5597 8 16.2423 8 15M16 3V15M16 21V15M8 15C8 12.7909 9.79086 11 12 11C14.2091 11 16 12.7909 16 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam5 = Vue.extend<IconProps>({
  name: 'Dam5Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'dam-5',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Dam5;
